import styled from 'styled-components';
import { Theme1 } from '../../theme/theme';

export const StyledText = styled.div`
  font-size: ${props => `calc(${props.size} * 1.2vw + 1rem)`};
  color: ${props => (props.isLightTheme ? Theme1.colors.text.defaultDark : Theme1.colors.text.defaultLight)};
  font-weight: ${props => props.fontWeight};
`
